import * as actionTypes from "./constants";

const initialState = {
  processing: false,
  error: false,
  getCafInfoById: [],
};

export default function SettingsReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_SETTINGS_MWRC_SLAB_RATE_INIT_ACTION:
      return {
        ...state,
        SlabRateList: [],
      };
    case actionTypes.FETCH_SETTINGS_MWRC_SLAB_RATE_SUCCESS_ACTION:
      return {
        ...state,
        SlabRateList: action.payload.response_data,
      };
    case actionTypes.FETCH_SETTINGS_MWRC_SLAB_RATE_FAIL_ACTION:
      return {
        ...state,
        SlabRateList: [],
      };
    case actionTypes.FETCH_SETTINGS_MWRC_FIXED_MONTHLY_CHARGE_SUCCESS_ACTION:
      return {
        ...state,
        FixedMonthlyCharge: action.payload.response_data,
      };
    case actionTypes.FETCH_SETTINGS_MWRC_FIXED_MONTHLY_CHARGE_INIT_ACTION:
      return {
        ...state,
        FixedMonthlyCharge: {},
      };
    case actionTypes.FETCH_SETTINGS_MWRC_FIXED_MONTHLY_CHARGE_FAIL_ACTION:
      return {
        ...state,
        FixedMonthlyCharge: {},
      };
    case actionTypes.FETCH_SETTINGS_MWRC_ADJUSTMENTS_INIT_ACTION:
      return {
        ...state,
        GetAdjustmentData: [],
      };
    case actionTypes.FETCH_SETTINGS_MWRC_ADJUSTMENTS_SUCCESS_ACTION:
      return {
        ...state,
        GetAdjustmentData: action.payload.response_data.adjustments,
      };
    case actionTypes.FETCH_SETTINGS_MWRC_ADJUSTMENTS_FAIL_ACTION:
      return {
        ...state,
        GetAdjustmentData: [],
      };
    case actionTypes.FETCH_SETTINGS_QUOTANOTSET_TABLE_INIT_ACTION:
      return {
        ...state,
        QuotaNotSetTable: [],
      };
    case actionTypes.FETCH_SETTINGS_QUOTANOTSET_TABLE_SUCCESS_ACTION:
      return {
        ...state,
        QuotaNotSetTable: action.payload.response_data.data,
      };
    case actionTypes.FETCH_SETTINGS_QUOTANOTSET_TABLE_FAIL_ACTION:
      return {
        ...state,
        QuotaNotSetTable: [],
      };
    case actionTypes.FETCH_SETTINGS_QUOTANOTSET_MODAL_INIT_ACTION:
      return {
        ...state,
        QuotaSetModal: [],
      };
    case actionTypes.FETCH_SETTINGS_QUOTANOTSET_MODAL_SUCCESS_ACTION:
      return {
        ...state,
        QuotaSetModal: action.payload,
      };
    case actionTypes.FETCH_SETTINGS_QUOTANOTSET_MODAL_FAIL_ACTION:
      return {
        ...state,
        QuotaSetModal: [],
      };
    case actionTypes.FETCH_SETTINGS_APARTMENT_INIT_ACTION:
      return {
        ...state,
        GetSettingApartment: [],
      };
    case actionTypes.FETCH_SETTINGS_APARTMENT_SUCCESS_ACTION:
      return {
        ...state,
        GetSettingApartment: action.payload.response_data.aptList,
      };
    case actionTypes.FETCH_SETTINGS_APARTMENT_FAIL_ACTION:
      return {
        ...state,
        GetSettingApartment: [],
      };
    case actionTypes.FETCH_SETTINGS_MWRC_BILL_CYCLE_INIT_ACTION:
      return {
        ...state,
        GetBillCycleDetail: {},
      };
    case actionTypes.FETCH_SETTINGS_MWRC_BILL_CYCLE_SUCCESS_ACTION:
      return {
        ...state,
        GetBillCycleDetail: action.payload.response_data,
      };
    case actionTypes.FETCH_SETTINGS_MWRC_BILL_CYCLE_FAIL_ACTION:
      return {
        ...state,
        GetBillCycleDetail: {},
      };
    case actionTypes.FETCH_SETTINGS_SOCIETY_PROFILE_INIT_ACTION:
      return {
        ...state,
        GetSocietyProfile: {},
      };
    case actionTypes.FETCH_SETTINGS_SOCIETY_PROFILE_SUCCESS_ACTION:
      return {
        ...state,
        GetSocietyProfile: action.payload.response_data,
      };
    case actionTypes.FETCH_SETTINGS_SOCIETY_PROFILE_FAIL_ACTION:
      return {
        ...state,
        GetSocietyProfile: {},
      };
    case actionTypes.FETCH_SETTINGS_SOCIETY_TEMPLATE_INIT_ACTION:
      return {
        ...state,
        GetSettingSocietyTemplate: [],
      };
    case actionTypes.FETCH_SETTINGS_SOCIETY_TEMPLATE_SUCCESS_ACTION:
      return {
        ...state,
        GetSettingSocietyTemplate: action.payload.response_data.templateid,
      };
    case actionTypes.FETCH_SETTINGS_SOCIETY_TEMPLATE_FAIL_ACTION:
      return {
        ...state,
        GetSettingSocietyTemplate: [],
      };
    case actionTypes.FETCH_SETTINGS_DAILY_QUOTA_GET_QUOTA_INIT_ACTION:
      return {
        ...state,
        GetAptQuota: [],
      };
    case actionTypes.FETCH_SETTINGS_DAILY_QUOTA_GET_QUOTA_SUCCESS_ACTION:
      return {
        ...state,
        GetAptQuota: action.payload.response_data.quota,
      };
    case actionTypes.FETCH_SETTINGS_DAILY_QUOTA_GET_QUOTA_FAIL_ACTION:
      return {
        ...state,
        GetAptQuota: [],
      };
    case actionTypes.FETCH_SETTINGS_REPORT_AUTO_GENERATE_INIT_ACTION:
      return {
        ...state,
        GetAutoGenerateStatus: {},
      };
    case actionTypes.FETCH_SETTINGS_REPORT_AUTO_GENERATE_SUCCESS_ACTION:
      return {
        ...state,
        GetAutoGenerateStatus: action.payload.response_data,
      };
    case actionTypes.FETCH_SETTINGS_REPORT_AUTO_GENERATE_FAIL_ACTION:
      return {
        ...state,
        GetAutoGenerateStatus: {},
      };
    case actionTypes.FETCH_SETTINGS_REPORT_SOCIETY_CONTACT_INIT_ACTION:
      return {
        ...state,
        GetSocietyContactDetail: {},
      };
    case actionTypes.FETCH_SETTINGS_REPORT_SOCIETY_CONTACT_SUCCESS_ACTION:
      return {
        ...state,
        GetSocietyContactDetail: action.payload.response_data,
      };
    case actionTypes.FETCH_SETTINGS_REPORT_SOCIETY_CONTACT_FAIL_ACTION:
      return {
        ...state,
        GetSocietyContactDetail: {},
      };
    case actionTypes.FETCH_SETTINGS_MWRC_FETCH_APARTMENT_INIT_ACTION:
      return {
        ...state,
        ApartmentList: [],
      };
    case actionTypes.FETCH_SETTINGS_MWRC_FETCH_APARTMENT_SUCCESS_ACTION:
      return {
        ...state,
        ApartmentList: action.payload.response_data.apts,
      };
    case actionTypes.FETCH_SETTINGS_MWRC_FETCH_APARTMENT_FAIL_ACTION:
      return {
        ...state,
        ApartmentList: [],
      };
    case actionTypes.FETCH_SETTINGS_METER_RENT_SUCCESS_ACTION:
      return {
        ...state,
        getCafInfo: action.payload.response_data["caf-info"],
      };
    case actionTypes.FETCH_SETTINGS_CAF_INIT_ACTION:
      return {
        ...state,
        getMeterRent: [],
      };
    case actionTypes.FETCH_SETTINGS_CAF_SUCCESS_ACTION:
      return {
        ...state,
        getMeterRent: action.payload.response_data,
      };
    case actionTypes.FETCH_SETTINGS_CAF_FAIL_ACTION:
      return {
        ...state,
        getMeterRent: [],
      };
    case actionTypes.FETCH_SETTINGS_CAFBYID_INIT_ACTION:
      return {
        ...state,
        getCafInfoById: [],
      };
    case actionTypes.FETCH_SETTINGS_CAFBYID_SUCCESS_ACTION:
      return {
        ...state,
        getCafInfoById: action.payload.response_data,
      };
    case actionTypes.FETCH_SETTINGS_CAFBYID_FAIL_ACTION:
      return {
        ...state,
        getCafInfoById: [],
      };

    default:
      return {
        ...state,
      };
  }
}
